<script setup>
import { useGlobalStore } from "@stores/global";
import { useTriviaStore } from "@stores/trivia";
import Button from "@components/Button.vue";

const globalStore = useGlobalStore();
const triviaStore = useTriviaStore();

function confirm() {
    const target = globalStore.modal.payload;
    globalStore.closeModal();
    triviaStore.reset();

    if (target === "trivia") {
        globalStore.showPanel("trivia");
        globalStore.setPage("trivia");
        return;
    }

    globalStore.hidePanel("trivia");

    if (target === "landing") {
        globalStore.exitToLanding();
    } else if (target) {
        globalStore.setPage(target);
    }
}
</script>

<template>
    <div class="flex w-full max-w-[400px] flex-col gap-8 p-8">
        <div class="flex flex-col gap-3">
            <p class="h5 leading-[0.9] font-bold tracking-tight uppercase">
                Leave trivia?
            </p>
            <p class="body-sm leading-[1.4] faded-text">
                Your current progress will be lost if you leave now.
            </p>
        </div>

        <div class="flex flex-col gap-2">
            <Button className="w-full!" @click="confirm">
                Leave
            </Button>
            <Button
                variant="secondary"
                className="w-full!"
                @click="globalStore.closeModal()"
            >
                Cancel
            </Button>
        </div>
    </div>
</template>
